// For now there is only text for Chat page
export const pl = {
  close: 'Zamknij',
  noContentError: 'Brak treści w obiekcie wiadomości',
  pleaseContactAdmin: 'Prosimy skontaktować się z administratorem',
  chatHistoryNotEnabled: 'Historia czatu nie jest włączona',
  errorTryAgain:
    'Wystąpił błąd. Spróbuj ponownie. Jeśli problem nadal występuje, skontaktuj się z administratorem strony.',
  tryAgain: 'Spróbuj ponownie',
  tryAgainMessage: 'Spróbuj ponownie. Jeśli problem nadal występuje, skontaktuj się z administratorem strony.',
  errorHistoryCannotBeSaved:
    'Wystąpił błąd podczas generowania odpowiedzi. W tej chwili nie można zapisać historii czatu.',
  errorOccurred: 'Wystąpił błąd.',
  errorCleaningCurrentChat: 'Błąd czyszczenia bieżącego czatu',
  errorAnswerCannotBeSaved:
    'Wystąpił błąd. W tej chwili nie można zapisać odpowiedzi. Jeśli problem będzie się powtarzał, skontaktuj się z administratorem strony.',
  errorCannotFetchChatState: 'Nie udało się pobrać bieżącego stanu czatu.',
  downloadChatHistory: 'Pobierz historię czatu',
  clearChat: 'Wyczyść czat',
  generatingAnswer: 'Generowanie odpowiedzi...',
  stopGenerating: 'Zatrzymaj generowanie',
  typeNewQuestion: 'Wpisz nowe pytanie',
  citations: 'Źródła',
  intents: 'Intencje',
  searchQuery: 'Wyszukiwane hasło:',
  searchResults: 'Wyniki wyszukiwania:',
}

export type PLDictionaryType = typeof pl
